import { paymentMethodTitle } from '@avalara/bat-apps-shared/helpers/payment-methods';
import { newPaymentMethodWording } from '../components/shared/payment/payment-method-selector';
export const selectDefaultPaymentMethod = (state) => {
    const { account: { paymentMethods } } = state;
    if (!paymentMethods || paymentMethods.length === 0)
        return null;
    return paymentMethods.find(a => a.defaultPaymentMethod) || null;
};
export const selectPaymentMethodSelectionInfo = (state) => {
    const { account: { paymentMethods, selectedPaymentMethod }, } = state;
    const selectedPaymentMethodId = (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.Id) || newPaymentMethodWording;
    const fieldValues = paymentMethods.map(p => ({
        wording: paymentMethodTitle(p),
        paymentMethod: p,
    }));
    return {
        selectedPaymentMethodId,
        fieldValues,
    };
};
